import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { getUniqueId } from '../../utils';
import { destroyFilesSession } from './actions';

/**
 * Hook into the component lifecycle to create a session reference that is
 * automatically returned when the component unmounts.
 *
 * @example
 *
 *   const sessionId = useFilesSession();
 *   dispatch(requestFiles(sessionId, ...));
 *
 */
export const useFilesSession = () => {
  const { current: sessionId } = useRef(getUniqueId());
  const dispatch = useDispatch();

  useEffect(() => () => dispatch(destroyFilesSession(sessionId)), []);

  return sessionId;
};
